/**
 * Las misiones vivas para el selector de la puerta (SALV-PUERTA-API-T1).
 *
 * GET /api/v1/Missions topa pageSize en 50 (MissionsController: "if (pageSize > 50) pageSize = 50"): pedir 200 trae 50.
 * Medido el 10-oct: 59 in_progress + 19 active + 10 draft = 88 vivas. Por eso se pide por estado y pagina a pagina.
 */
import { MissionApiClient } from '../../infrastructure/api/MissionApiClient.js';
import { misionesVivas } from './puertaTarea.js';

// por_cerrar entra: la puerta de tareas la acepta (trabajo_guardas_v2) y una tarea nueva la devuelve a in_progress.
const ESTADOS_VIVOS = ['in_progress', 'active', 'por_cerrar', 'draft'];
const POR_PAGINA = 50;
const PAGINAS_MAX = 10;

let cache = null;

/** @returns {Promise<{ok: boolean, misiones: {code: string, title: string, status: string}[], error?: string}>} */
export async function cargarMisionesVivas({ fresco = false } = {}) {
  if (cache && !fresco) return cache;
  const respuestas = [];
  for (const status of ESTADOS_VIVOS) {
    for (let page = 1; page <= PAGINAS_MAX; page++) {
      const res = await MissionApiClient.list(page, POR_PAGINA, { status });
      if (!res.ok) return { ok: false, misiones: [], error: res.error || 'No se pudo leer las misiones' };
      respuestas.push(res);
      const d = res.data?.data ?? res.data ?? {};
      const items = Array.isArray(d) ? d : (d.items ?? []);
      if (!Array.isArray(items) || items.length < POR_PAGINA) break;
    }
  }
  cache = { ok: true, misiones: misionesVivas(...respuestas) };
  return cache;
}
